import { marginBalanceKeys } from 'app/(trade)/queries/marginBalance';
import { getQueryClient } from 'app/get-query-client';
import { portfolioBalanceKeys } from 'lib/queries/portfolioBalance';
import { depositsKeys } from 'queries/deposits';
import { intraExchangeTransfersKeys } from 'queries/intraExchangeTransfers';
import { paymentsMetadataKeys } from 'queries/paymentsMetadata';
import { portfolioCurrentKeys } from 'queries/portfolioCurrent';

export function invalidateAllBalanceQueries() {
    const qc = getQueryClient();
    qc.invalidateQueries({ queryKey: portfolioCurrentKeys.all });
    qc.invalidateQueries({ queryKey: portfolioBalanceKeys.all });
    qc.invalidateQueries({ queryKey: marginBalanceKeys.all });
    qc.invalidateQueries({ queryKey: intraExchangeTransfersKeys.all });
    qc.invalidateQueries({ queryKey: depositsKeys.all });
    qc.invalidateQueries({ queryKey: paymentsMetadataKeys.all });
}
